import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          title: '!text-default',
          description: '!text-long-secondary',
          actionButton: '!bg-transparent !text-primary hover:!underline !p-0',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--background)',
          '--normal-text': 'var(--foreground)',
          '--normal-border': 'var(--border)',
          '--success-bg': 'var(--secondary)',
          '--success-text': 'var(--default)',
          '--success-border': 'var(--primary)',
          '--error-bg': 'var(--destructive-background)',
          '--error-text': 'var(--default)',
          '--error-border': 'var(--destructive)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
